export default __webpack_public_path__ + "static/media/GolosRegular.94ea974b.woff2";